import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import { userTypes } from 'constants/user'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'
import { _studentsCount } from 'store/selectors/Room'

import { Controls, Control, Icon } from './styles'

const ICON_BASE_PATH = '/img/artefacts/whiteboard/toolbar'

const ControlBarLeft = ({
    onChangeColor,
    onErase,
    clearCanvas,
    onPenClick,
    onSizeToggle,
    onUndo,
    onRedo,
    disableUndo,
    disableRedo,
}) => {
    const { isWhiteboardMode } = useVideoContext()
    const [selectedIcon, setSelectedIcon] = useState('pencil')
    const studentsCount = useSelector(_studentsCount)

    const { userType } = useVideoContext()

    const controls = [
        {
            src: `${ICON_BASE_PATH}/${
                selectedIcon === 'pencil'
                    ? 'pencilIconWhite.svg'
                    : 'pencilIcon.svg'
            }`,
            alt: 'pencil',
            onClick: () => {
                onPenClick()
                setSelectedIcon('pencil')
            },
        },
        {
            src: `${ICON_BASE_PATH}/${
                selectedIcon === 'color-palette'
                    ? 'colorWhite.svg'
                    : 'color.svg'
            }`,
            alt: 'color-palette',
            onClick: () => {
                onChangeColor()
                if (selectedIcon === 'color-palette') {
                    setSelectedIcon('pencil')
                } else {
                    setSelectedIcon('color-palette')
                }
            },
        },
        {
            src: `${ICON_BASE_PATH}/${
                selectedIcon === 'eraser'
                    ? 'eraserIconWhite.svg'
                    : 'eraserIcon.svg'
            }`,
            alt: 'eraser',
            onClick: () => {
                onErase(15, '#fafafa')
                setSelectedIcon('eraser')
            },
        },
        {
            src: `${ICON_BASE_PATH}/clear.svg`,
            alt: `clear-all`,
            onClick: () => {
                clearCanvas()
            },
        },
        {
            src: `${ICON_BASE_PATH}/undo.svg`,
            alt: `undo`,
            onClick: () => {
                onUndo()
            },
        },
        {
            src: `${ICON_BASE_PATH}/redo.svg`,
            alt: `redo`,
            onClick: () => {
                onRedo()
            },
        },
    ]

    return (
        <Controls
            isWhiteboardMode={isWhiteboardMode}
            studentsCount={studentsCount}
        >
            {userType === userTypes.TEACHER &&
                controls.map(control => (
                    <Control
                        key={control.alt}
                        onClick={control.onClick}
                        isClicked={control.alt === selectedIcon}
                        disableUndo={control.alt === 'undo' && disableUndo}
                        disableRedo={control.alt === 'redo' && disableRedo}
                    >
                        <Icon src={control.src} alt={control.alt} />
                    </Control>
                ))}
        </Controls>
    )
}

export default ControlBarLeft
